import React, { forwardRef } from "react";
import s from "styled-components";
import PT from "prop-types";

export const StyledRadio = s.div`
display: inline-block;
margin-inline-end: 15px;
input:checked,
input:not(:checked) {
  position: absolute;
  left: -9999px;
}
input:checked + label,
input:not(:checked) + label
{
    position: relative;
    padding-left: 25px;
    cursor: pointer;
    line-height: 20px;
    display: inline-block;
    color: var(--font-color-accent);
}
label {
  font-size: 16px;
  font-weight: 500;
}
input:disabled + label {
  opacity: .55;
}
input:checked + label:before,
input:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 18px;
    height: 18px;
    border: 1px solid #ddd;
    border-radius: 100%;
    background: #fff;
}
input:checked + label:after,
input:not(:checked) + label:after {
    content: '';
    width: 12px;
    height: 12px;
    background: var(--color-primary);
    position: absolute;
    top: 3px;
    left: 3px;
    border-radius: 100%;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
}
input:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
}
input:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
}
`;
const RadioButton = (props) => {
  return (
    <StyledRadio>
      <input
        disabled={props.disabled}
        checked={props.checked}
        onChange={props.onChange}
        value={props.value}
        type="radio"
        id={props.id}
        name={props.name}
      />
      <label htmlFor={props.id}>{props.label}</label>
    </StyledRadio>
  );
};
RadioButton.propTypes = {
  label: PT.string,
  name: PT.string,
  id: PT.string,
  value: PT.any,
  checked: PT.bool,
  onChange: PT.func,
  disabled: PT.bool,
};
export const UncontrolledRadio = forwardRef((props, ref) => {
  return (
    <StyledRadio>
      <input ref={ref} {...props} type="radio" />
      <label htmlFor={props.id}>{props.label}</label>
    </StyledRadio>
  );
});
UncontrolledRadio.displayName = "UncontrolledRadio";
export default RadioButton;
